<template>
  <LabelObjectSetForm ref="objectForm" :sample_id="sample_id" :label_set_id="label_set_id">
    <template v-slot:nav-buttons>
      <b-button-group>
        <b-button :disabled="loading == true" @click="previousElement()">
          <i class="fa fa-lg fa-angle-left" />
        </b-button>

        <b-button v-model="index" v-if="loading == false">
          {{ (index + 1) + " of " + list.data.length }}
        </b-button>
        <b-button v-else>
          <b-spinner small type="grow"></b-spinner>
          <b-spinner small type="grow"></b-spinner>
          <b-spinner small type="grow"></b-spinner>
        </b-button>
        <b-button :disabled="loading == true" @click="nextElement()">
          <i class="fa fa-lg fa-angle-right" />
        </b-button>
      </b-button-group>
    </template>
  </LabelObjectSetForm>
</template>
<script>
import { mapState } from 'vuex';
import LabelObjectSetForm from '@/views/LabelObjectSets/LabelObjectSetForm';
import Services from '@/services/index';

export default {
  props: {
    sample_id: { type: Number, default: null },
    label_set_id: { type: Number, default: null },
  },
  components: {
    LabelObjectSetForm
  },
  data() {
    return {
      loading: true,
      list: {},
      nextSampleId: null,
      index: null,
      navigationInProgress: false,
      keyDownHandler: null,
    };
  },
  computed: {
    params() {
      return {
        ...this.$route.query.filter ? JSON.parse(this.$route.query.filter) : {},
        light_weight: true,
        notpaginate: 1,
      };
    },

    ...mapState('Auth', ['activeProjectId', 'token']),
  },
  mounted() {
    this.getData();
    this.keyDownHandler = this.keydown_window.bind(this);
    window.addEventListener('keydown', this.keyDownHandler);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.keyDownHandler);
  },
  methods: {
    keydown_window(e) {
      if (this.navigationInProgress) { return; }

      if (e.key === 'PageUp') {
        this.nextElement();
      }
      if (e.key === 'PageDown') {
        this.previousElement();
        e.preventDefault();
      }
    },
    previousElement() {
      this.index = this.list.data.findIndex((obj) => obj.id === this.sample_id);
      if (this.index > 0) {
        this.index--;
        this.nextSampleId = this.list.data[this.index].id;
        this.navigationInProgress = true;
        this.$router.push({
          name: 'LabelSample',
          params: { sample_id: this.nextSampleId || this.sample_id, label_set_id: this.label_set_id },
        }).finally(() => { this.navigationInProgress = false; });
      }
    },
    nextElement() {
      this.index = this.list.data.findIndex((obj) => obj.id === this.sample_id);
      if (this.index >= 0 && this.index < this.list.data.length - 1) {
        this.index++;
        this.nextSampleId = this.list.data[this.index].id;
        this.navigationInProgress = true;
        this.$router.push({
          name: 'LabelSample',
          params: { sample_id: this.nextSampleId || this.sample_id, label_set_id: this.label_set_id },
        }).finally(() => { this.navigationInProgress = false; });
      }
    },
    getData() {
      this.loading = true;
      Services.labelSets.sampleList(this.activeProjectId, this.label_set_id, this.params).then(({ data }) => {
        this.list = data;
        this.loading = false;
        this.index = this.list.data.findIndex((obj) => obj.id === this.sample_id);
      }).catch((err) => { this.loading = false; console.error(err); });
    },
  },
  async beforeRouteUpdate(_to, _from, next) {
    try {
      await this.$refs.objectForm.checkForUnsavedChanges();
      next();
    } catch {
      next(false);
    }
  },
  async beforeRouteLeave(_to, _from, next) {
    try {
      await this.$refs.objectForm.checkForUnsavedChanges();
      next();
    } catch {
      next(false);
    }
  },
};

</script>
